module.exports = __webpack_public_path__ + "static/media/up-arrow.035ad968.svg";